<div class="row col-12">
  <form class="col-12 p-5" [formGroup]="formEntity">
    <fieldset>
      <legend class="form-title">{{ titulo }}</legend>
      <div class="form-row p-4 mt-3 text-center justify-content-center d-flex custom-box">
        <div class="form-check form-check-inline">
          <input mdbInput class="form-check-input" type="radio" id='corretora' name='tipoEntidade' value="Corretora" formControlName="tipoEntidade"/>
          <label for="corretora" class="select-tipos">Corretora</label>
        </div>
        <div class="form-check form-check-inline">
          <input mdbInput class="form-check-input" type="radio" id='admFundos' name='tipoEntidade' value="Adm. Fundos" formControlName="tipoEntidade"/>
          <label for="admFundos" class="select-tipos">Adm. Fundos</label>
        </div>
        <div class="form-check form-check-inline">
          <input mdbInput class="form-check-input" type="radio" id='DTVM' name='tipoEntidade' value="DTVM" formControlName="tipoEntidade"/>
          <label for="DTVM" class="select-tipos">DTVM</label>
        </div>
      </div>

      <div class="form-row mt-4">
        <div class="form-group col-sm-12 col-md-6">
          <label class="form-label">CNPJ *</label>
          <input mask="00.000.000/0000-00" formControlName="documentoIdentificador" autocomplete="off" placeholder="00.000.000/0000-00" name="CNPJ" type="text" class="form-control custom-input">
          <span class="error-form ml-2" *ngIf="documentoIdentificadorCNPJ.invalid && (documentoIdentificadorCNPJ.dirty || documentoIdentificadorCNPJ.touched)">Campo obrigatório.</span>
        </div>
        <div class="form-group col-sm-12 col-md-6">
          <label class="form-label">Razão Social *</label>
          <input maxlength="150" placeholder="Digite o nome" formControlName="razaoSocial" autocomplete="off" name="nomeCompleto" type="text" class="form-control custom-input">
          <span class="error-form ml-2" *ngIf="razaoSocial?.hasError('required') && (razaoSocial.dirty || razaoSocial.touched)">Campo obrigatório.</span>
          <span class="error-form ml-2" *ngIf="razaoSocial?.hasError('pattern')">Campo contém caracteres inválidos.</span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-sm-12 col-md-4">
          <label  class="form-label">DDI *</label>
          <select name='ddi' formControlName="codigoDdi" autocomplete="off" name="ddi" type="text" class="form-control custom-input">
            <option selected value="">Selecione uma opção</option>
            <option value="+55">Brasil</option>
            <option *ngFor="let opt of tableDdi" value="{{opt.code}}">{{opt.name}}</option>
          </select>
        <span class="error-form ml-2" *ngIf="codigoDdi.invalid && (codigoDdi.dirty || codigoDdi.touched)">Campo obrigatório.</span>
        </div>
        <div class="form-group col-sm-12 col-md-4">
          <label class="form-label">Telefone <i mdbTooltip='Este campo só é obrigatório caso o campo "Celular" não seja preenchido.'  placement="top" class="ml-3 fas fa-question-circle"></i></label>
          <input formControlName="telefone" autocomplete="off" [mask]="maskTelefone(1)" name="telefone" type="text" class="form-control custom-input" placeholder="(00) 0000-0000">
            <span class="error-form ml-2" *ngIf="telefone.errors?.minlength">Telefone deve ter 10 dígitos.</span>
            <span class="error-form ml-2" *ngIf="telefone.invalid && (telefone.dirty || telefone.touched)">Informe um telefone válido.</span>
        </div>
        <div class="form-group col-sm-12 col-md-4">
          <label class="form-label">Celular <i mdbTooltip='Este campo só é obrigatório caso o campo "Telefone" não seja preenchido.'  placement="top" class="ml-3 fas fa-question-circle"></i></label>
          <input formControlName="celular" autocomplete="off" [mask]="maskTelefone(2)" name="celular" type="text" class="form-control custom-input" placeholder="(00) 00000-0000">
            <span class="error-form ml-2" *ngIf="celular.errors?.minlength">Celular deve ter 11 dígitos.</span>
            <span class="error-form ml-2" *ngIf="celular.invalid && (celular.dirty || celular.touched)">Informe um celular válido.</span>
          </div>
      </div>
    </fieldset>
    <div class="form-row mt-5 mb-3 d-flex justify-content-center">
      <div *ngIf="mostrarBotaoVoltar" class="col-md-4 d-flex justify-content-center">
        <button data-testid="botao-voltar" (click)="voltar.emit()" class="btn">
          Voltar
        </button>
      </div>
      <div class="col-md-4 d-flex justify-content-center">
        <button (click)="efetuarCadastro.emit()" class="btn" [disabled]="nextDisabled">Finalizar cadastro</button>
      </div>
    </div>
  </form>
</div>
